import { useTranslation } from "react-i18next";
import { Check, Minus } from "lucide-react";

const PLAN_IDS = ["free", "premium", "family"];

function Cell({ value, testId, t }) {
  if (value === true) return <Check data-testid={testId} aria-label={t("sts.pricing.compare.included")} className="h-4 w-4 mx-auto text-[#00A373]" />;
  if (value === false) return <Minus data-testid={testId} aria-label={t("sts.pricing.compare.notIncluded")} className="h-4 w-4 mx-auto text-slate-300" />;
  return <span data-testid={testId} className="font-medium text-[#0A1128]">{value}</span>;
}

export default function PlanComparison() {
  const { t } = useTranslation("products");
  const rows = t("sts.pricing.compare.rows", { returnObjects: true });
  const names = PLAN_IDS.map((id) => t(`sts.pricing.plans.${id}.name`));
  return (
    <div data-testid="sts-plan-comparison" className="mt-16 max-w-5xl mx-auto">
      <div className="text-center">
        <p className="text-[12px] uppercase tracking-[0.18em] text-slate-500">{t("sts.pricing.compare.eyebrow")}</p>
        <h3 className="font-display mt-2 text-[26px] md:text-[32px] text-[#0A1128] leading-tight">
          {t("sts.pricing.compare.title")}
        </h3>
      </div>
      <div className="mt-8 overflow-x-auto rounded-2xl border border-slate-200 bg-white af-shadow-card">
        <table className="w-full min-w-[620px] text-[13px] sm:text-[14px]">
          <thead>
            <tr className="bg-[#F7F9FC] border-b border-slate-200">
              <th scope="col" className="text-left font-medium text-slate-500 px-4 sm:px-6 py-4">{t("sts.pricing.compare.feature")}</th>
              {names.map((n, j) => (
                <th key={PLAN_IDS[j]} scope="col" className={`w-[21%] font-display text-[15px] text-[#0A1128] px-2 py-4 ${j === 2 ? "bg-[#E6FAF4]" : ""}`}>
                  {n}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map(([label, ...vals], i) => (
              <tr key={label} data-testid={`sts-compare-row-${i}`} className="border-b border-slate-100 last:border-0 hover:bg-slate-50/60 transition-colors">
                <th scope="row" className="text-left font-normal text-slate-700 px-4 sm:px-6 py-3.5">{label}</th>
                {vals.map((v, j) => (
                  <td key={PLAN_IDS[j]} className={`text-center px-2 py-3.5 leading-snug ${j === 2 ? "bg-[#E6FAF4]/50" : ""}`}>
                    <Cell value={v} t={t} testId={`sts-compare-${PLAN_IDS[j]}-${i}`} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-[12px] text-slate-500">{t("sts.pricing.compare.footnote")}</p>
    </div>
  );
}
